export enum DaysOfWeek {
  sunday = 0,
  monday = 1,
  tuesday = 2,
  wednesday = 3,
  thursday = 4,
  friday = 5,
  saturday = 6,
}

export interface RadioButtonOption {
  value: string | number;
  title?: string;
  titleKey?: string;
  subTitle?: string;
  subTitleKey?: string;
  description?: string;
  descriptionKey?: string;
  icon?: string;
  disabled?: boolean;
  tooltip?: string;
}
